import { defineMessages } from '../../i18n/messages';

export const WhatYouGetMessages = defineMessages({
  TITLE: {
    id: 'homepage.what_you_get.title',
    text: 'Everything You Need to Go Global',
    description: 'Section heading for the product features overview. "Go global" means making an application available in multiple languages worldwide.',
  },
  SUBTITLE: {
    id: 'homepage.what_you_get.subtitle',
    text: 'Not just a translation API. A complete localization platform from code migration to production.',
    description: 'Subtitle that positions Localingos as more than a simple API. "Code migration" means converting a codebase to support multiple languages. "Production" means the live deployed application.',
  },
  CLI_TITLE: {
    id: 'homepage.what_you_get.cli_title',
    text: 'Free CLI Tool',
    description: 'Title for a feature card about the command line tool. "CLI" stands for Command Line Interface.',
  },
  CLI_DESC: {
    id: 'homepage.what_you_get.cli_desc',
    text: 'Install, configure, and sync from your terminal. Fits into any CI/CD pipeline.',
    description: 'Description for the CLI feature card. "Terminal" is the command line application. "CI/CD pipeline" is a continuous integration/deployment workflow used in software development.',
  },
  PROMPT_TITLE: {
    id: 'homepage.what_you_get.prompt_title',
    text: 'AI Migration Prompt',
    description: 'Title for a feature card about the AI-generated migration prompt. A "prompt" is a set of instructions given to an AI coding assistant.',
  },
  PROMPT_DESC: {
    id: 'homepage.what_you_get.prompt_desc',
    text: 'Auto-generated prompt for Cursor, Copilot, or any AI agent to migrate your codebase to i18n.',
    description: 'Description for the AI prompt feature card. "Cursor" and "Copilot" are AI coding assistants. "i18n" is the abbreviation for internationalization. "Codebase" is the source code of a project.',
  },
  PIPELINE_TITLE: {
    id: 'homepage.what_you_get.pipeline_title',
    text: 'Translation Pipeline',
    description: 'Title for a feature card about the automated translation system. A "pipeline" is an automated sequence of processing steps.',
  },
  PIPELINE_DESC: {
    id: 'homepage.what_you_get.pipeline_desc',
    text: 'Diff-based, variable-safe translations powered by the best LLM. 56 locales, 1,000+ translations/min.',
    description: 'Description for the translation pipeline feature card. "Diff-based" means only changed strings are processed. "Variable-safe" means code placeholders are preserved. "LLM" is Large Language Model. "1,000+" means more than one thousand.',
  },
  DASHBOARD_TITLE: {
    id: 'homepage.what_you_get.dashboard_title',
    text: 'Web Dashboard',
    description: 'Title for a feature card about the web-based management interface.',
  },
  DASHBOARD_DESC: {
    id: 'homepage.what_you_get.dashboard_desc',
    text: 'Review translations, manage projects, track usage, and invite team members, all in one place.',
    description: 'Description for the dashboard feature card. Lists the main actions available in the web interface.',
  },
  MCP_TITLE: {
    id: 'homepage.what_you_get.mcp_title',
    text: 'MCP Server',
    description: 'Title for a feature card. "MCP" stands for Model Context Protocol, a standard for connecting AI assistants to external tools. Keep "MCP" as a technical abbreviation.',
  },
  MCP_DESC: {
    id: 'homepage.what_you_get.mcp_desc',
    text: 'Connect your AI assistant directly to Localingos. Push, pull, and manage translations from chat.',
    description: 'Description for the MCP feature card. Explains that AI assistants can interact with Localingos directly through conversation. "Push" means upload, "pull" means download.',
  },
  API_TITLE: {
    id: 'homepage.what_you_get.api_title',
    text: 'REST API',
    description: 'Title for a feature card. "REST API" is a technical term for a web service interface. Do not translate.',
  },
  API_DESC: {
    id: 'homepage.what_you_get.api_desc',
    text: 'Full API access for custom integrations. Build your own workflows on top of Localingos.',
    description: 'Description for the REST API feature card. "API" is Application Programming Interface. "Localingos" is the product name, do not translate.',
  },
  INCLUDED: {
    id: 'homepage.what_you_get.included',
    text: 'All included in every plan, even the free tier',
    description: 'Note displayed below the feature cards. Emphasizes that all features listed above are available on every pricing plan, including the free one.',
  },
});
